/* eslint-disable react/require-default-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { PERIOD_PRESETS } from '../constants';
import { computePeriodRange, detectPeriodKey } from '../utils/period';
import { Chip, ChipRow, ShellChip } from '../styles';

// ---------------------------------------------------------------------------
// Atalhos de período de emissão.
//
// Extraído porque aparece em duas superfícies com o mesmo comportamento e
// aparências diferentes: dentro da barra de filtros (card branco) e na barra
// fixa que desce ao rolar (fundo escuro do shell). Uma cópia por superfície
// significaria dois lugares para o preset divergir.
//
// ⚠️ Os presets dependem do `reference_date` do SERVIDOR. Sem ele, só "Tudo"
// está habilitado — "Este mês" exigiria adivinhar a data no fuso do navegador.
// ---------------------------------------------------------------------------

const PRESET_KEYS = PERIOD_PRESETS.map((preset) => preset.key);

export default function PeriodChips({
   from,
   to,
   referenceDate,
   onSelect,
   tone = 'light',
}) {
   const activePreset = useMemo(
      () => detectPeriodKey({ from, to }, referenceDate, PRESET_KEYS),
      [from, to, referenceDate],
   );

   const ChipComponent = tone === 'dark' ? ShellChip : Chip;

   return (
      <ChipRow role="group" aria-label="Período de emissão">
         {PERIOD_PRESETS.map((preset) => {
            const unavailable = preset.key !== 'tudo' && !referenceDate;
            return (
               <ChipComponent
                  key={preset.key}
                  type="button"
                  $active={activePreset === preset.key}
                  aria-pressed={activePreset === preset.key}
                  disabled={unavailable}
                  title={
                     unavailable
                        ? 'Disponível assim que a data de referência do servidor carregar'
                        : undefined
                  }
                  onClick={() => {
                     const range = computePeriodRange(preset.key, referenceDate);
                     if (range) onSelect(range);
                  }}
               >
                  {preset.label}
               </ChipComponent>
            );
         })}
      </ChipRow>
   );
}

PeriodChips.propTypes = {
   from: PropTypes.string,
   to: PropTypes.string,
   referenceDate: PropTypes.string,
   onSelect: PropTypes.func.isRequired,
   tone: PropTypes.oneOf(['light', 'dark']),
};
